import React from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../../../../components/pageTitle';
import Navigation from '../../../../../components/navigation';
import FeedbackSimple from '../simple';
import Reactions from '../../../../../components/reactions';
import FeedbackService from '../../../../../services/feedback.service';
import Comments from '../../../../../components/comments';
import AttachedFile from '../../../../../components/files/attachedFile';


const Feedback = ({
  t,
  item,
  commented,
  moduleTitle,
  backgroundCover,
  enableCoverColor,
  backgroundColor,
}) => (
  <React.Fragment>
    <PageTitle
      title={moduleTitle}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs simplepage2_D">
      <div className="container">
        <div className="Blog2inner boxs pdlr pdlrzero">
          <Navigation />
          <div className="middleKB">
            <div className="BlogsBoxouter boxs feedbckitem">
              <FeedbackSimple item={item} />
            </div>
            <div className="feedbackcmnt boxs">
              <div className="feedbckwidth boxs">
                <svg aria-hidden="true" focusable="false" style={{ width: 0, height: 0, position: 'absolute' }}>
                  <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
                    <stop offset="0%" stopColor="var(--color-stop-1)" />
                    <stop offset="100%" stopColor="var(--color-stop-2)" />
                  </linearGradient>
                </svg>
                {item.files && item.files.length ?
                  <div className="boxs fontmulisemi Attchfilefdbck Attchfiletckt Attchfiletckt3">
                    <div className="leftfbw">
                      <div className="boxs">
                        <span className="attchfilefbck ">{t('Attached files')}<span>( { item.files.length} )</span>:</span>
                      </div>
                    </div>
                    <div className="middlefbw">
                      <div className="boxs">
                        {item.files.map(file => (
                          <div key={file.id}>
                            <AttachedFile
                              file={file}
                              files={item.files}
                              viewOnly
                              mult
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div> : ''}
                <Reactions
                  cssClass={`emoj-list ${backgroundColor}`}
                  model_id={item.id}
                  model_name={FeedbackService.modelName}
                />
                <Comments
                  backgroundColor={backgroundColor}
                  model_id={item.id}
                  commented={true}
                  model_name={FeedbackService.modelName}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Feedback.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/views/modules/feedback/feedbackItem/ext/Feedback.jsx